export const ACTION_SET_PREVIEW_WORDS = "SET_PREVIEW_WORDS";
export const ACTION_SET_DELETE_WORDS = "SET_DELETE_WORDS";
export const ACTION_SET_SIGN_WORDS = "SET_SIGN_WORDS";
export const ACTION_SET_REMOVE_WORDS = "SET_REMOVE_WORDS";
export const ACTION_SET_DELETE_WORD = "SET_DELETE_WORD";
export const ACTION_SET_HAVE_WORDS_COUNT = "SET_HAVE_WORDS_COUNT";
export const ACTION_SET_FILTER_WORDS = `SET_FILTER_WORDS`;
export const ACTION_SET_ADD_NEW_WORDS = "SET_ADD_NEW_WORDS";
export const ACTION_SET_ADD_PREVIEW_WORD = "SET_ADD_PREVIEW_WORD";
export const ACTION_SET_DELETE_NOT_WORD = "SET_DELETE_NOT_WORD";
export const ACTION_SET_EXISTING_WORDS_IN_ARTICLE =
  "SET_EXISTING_WORDS_IN_ARTICLE";
export const setPreviewWords = (preview_words) => {
  return {
    type: ACTION_SET_PREVIEW_WORDS,
    payload: preview_words,
  };
};
export const setDeleteWord = (wordInfo) => {
  return {
    type: ACTION_SET_DELETE_WORD,
    payload: wordInfo,
  };
};

export const setAddPreviewWord = (wordObj) => {
  return {
    type: ACTION_SET_ADD_PREVIEW_WORD,
    payload: wordObj,
  };
};

export const setDeleteNotWord = (wordInfo) => {
  return {
    type: ACTION_SET_DELETE_NOT_WORD,
    payload: wordInfo,
  };
};

export const setExistingWordsInArticle = (existing_words_in_article) => {
  return {
    type: ACTION_SET_EXISTING_WORDS_IN_ARTICLE,
    payload: existing_words_in_article,
  };
};

export const setSignWords = (sign_words) => {
  return {
    type: ACTION_SET_SIGN_WORDS,
    payload: sign_words,
  };
};

export const setRemoveWords = (remove_words) => {
  return {
    type: ACTION_SET_REMOVE_WORDS,
    payload: remove_words,
  };
};
export const setHaveWordsCount = (count) => {
  return {
    type: ACTION_SET_HAVE_WORDS_COUNT,
    payload: count,
  };
};
export const setAddNewWords = (add_new_words) => {
  return {
    type: ACTION_SET_ADD_NEW_WORDS,
    payload: add_new_words,
  };
};

export const setAnalysisResult = (res) => {
  return (dispatch) => {
    const {
      res_words,
      sign_words,
      remove_words,
      have_words_count,
      add_new_words,
      existing_words_in_article,
    } = res;
    
    // dispatch(setPreviewWords(res_words));
    dispatch(setPreviewWords(res_words?.concat(add_new_words)));
    dispatch(setSignWords(sign_words));
    dispatch(setRemoveWords(remove_words));
    dispatch(setHaveWordsCount(have_words_count));
    dispatch(setAddNewWords(add_new_words));
    dispatch(setExistingWordsInArticle(existing_words_in_article));
  };
};
